import {
  SOURCE_AVATAR_COLORS,
  SOURCE_ICON_BY_NAME
} from '../constants/leadSources';

export const normalizeSourceName = (name: string) =>
  name.trim().toLowerCase().replace(/\s+/g, ' ');

export const getSourceIconName = (name: string): string | undefined =>
  SOURCE_ICON_BY_NAME[normalizeSourceName(name)];

export const getSourceInitials = (name: string) =>
  name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase() ?? '')
    .join('');

/** Stable “random” palette pick so the same source keeps the same color. */
export const getSourceAvatarColor = (name: string) => {
  const normalized = normalizeSourceName(name);
  let hash = 0;
  for (let i = 0; i < normalized.length; i += 1) {
    hash = (hash + normalized.charCodeAt(i) * (i + 1)) % 2147483647;
  }
  return SOURCE_AVATAR_COLORS[hash % SOURCE_AVATAR_COLORS.length];
};
